import { render } from "./Customersupport.vue?vue&type=template&id=71ad0ba8&scoped=true"
import script from "./Customersupport.vue?vue&type=script&lang=js"
export * from "./Customersupport.vue?vue&type=script&lang=js"

import "./Customersupport.vue?vue&type=style&index=0&id=71ad0ba8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71ad0ba8"]])

export default __exports__